import { memo } from 'react'
import Modal from 'react-bootstrap/Modal';

const BzModalTitle = ({ className, ...props }) => {
    return (
        <Modal.Title  {...props} className={className}>
            {props.children}
        </Modal.Title>
    )
}

export default memo(BzModalTitle)





